import { loadDeviceId, saveDeviceId } from '@/storage/storage';
import { uid } from '@/utils';
const API_URL = process.env.APP_API_URL ?? '';
let _getToken = null;
let _deviceId = null;
export function setTokenGetter(getter) {
    _getToken = getter;
}
export async function getDeviceId() {
    if (_deviceId)
        return _deviceId;
    const stored = await loadDeviceId();
    if (stored) {
        _deviceId = stored;
        return stored;
    }
    const id = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : uid();
    await saveDeviceId(id);
    _deviceId = id;
    return id;
}
async function request(method, path, body) {
    const token = _getToken?.() ?? null;
    const deviceId = await getDeviceId();
    const headers = {
        'X-Device-Id': deviceId,
    };
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    if (body !== undefined) {
        headers['Content-Type'] = 'application/json';
    }
    const res = await fetch(`${API_URL}${path}`, {
        method,
        headers,
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    if (!res.ok) {
        let errors = [];
        try {
            const json = await res.json();
            errors = json.errors ?? [];
        }
        catch {
            // response body is not JSON
        }
        const err = { status: res.status, errors };
        throw err;
    }
    if (res.status === 204) {
        return undefined;
    }
    const json = await res.json();
    return json.data;
}
export function apiGet(path) {
    return request('GET', path);
}
export function apiPost(path, body) {
    return request('POST', path, body);
}
export function apiPut(path, body) {
    return request('PUT', path, body);
}
export function apiDelete(path) {
    return request('DELETE', path);
}
